var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 2 1.88 1.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.12 3.88 16 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20v-9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53 9C4.6 8.8 3 7.1 3 5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13H2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21c0-2.1 1.7-3.9 3.8-4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.97 5c0 2.1-1.6 3.8-3.5 4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13h-4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 17c2.1.1 3.8 1.9 3.8 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.af01acd45c62e9a885f63bebe43f8f51.svg";
export { ForwardRef as ReactComponent };